import Vue from "vue";
import VueI18n from "vue-i18n";
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
import cht from 'view-design/dist/locale/zh-TW';
import es from 'view-design/dist/locale/es-ES';
import ar from 'view-design/dist/locale/ar-EG';
import ru from 'view-design/dist/locale/ru-RU';
console.log(zh)
Vue.use(VueI18n); // 全局挂载
Vue.locale = () => {};
const LANG_MAP = {
  "zh-CN": "zh",
  "zh-TW": "cht",
  "en-US": "en",
  cht: "cht",
  en: "en",
  zh: "zh",
  "es-ES": "es", // 西班牙语
  es: "es",
  "ar-EG": "ar", // 阿拉伯语（埃及）
  ar: "ar",
  "ru-RU": "ru", // 俄语（俄罗斯）
  ru: "ru",
};
const LANG_NAME_MAP = Object.entries(LANG_MAP).reduce((acc, [key, value]) => {
  if (value !== key) {
      Reflect.set(acc, value, key);
      Reflect.set(acc, key, key);
  }
  return acc;
}, {});
export const i18n = new VueI18n({
  legacy: false,
  globalInjection: true, // 全局注册$t方法
  locale: 'zh-CN',
  messages: {
    'zh-CN':  Object.assign(require("./lan/zh"), zh), // 中文语言包
    'en-US': Object.assign(require("./lan/en"), en), // 英文语言包
    'zh-TW': Object.assign(require("./lan/cht"), cht), // 繁体中文语言包
    'es-ES': Object.assign(require("./lan/es"), es), // 西班牙语语言包
    'ar-EG': Object.assign(require("./lan/ar"), ar), // 阿拉伯语语言包
    'ru-RU': Object.assign(require("./lan/ru"), ru), // 俄语语言包
  }
});
export function useLan(lang) {
  if (!lang) return ;
  const lan = LANG_NAME_MAP[lang] || "zh-CN";
  i18n.locale = lan;
}
export function getLocaleMapLang() {
  return LANG_MAP[i18n.locale] || "zh";
}
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js